<template>
    <v-container fluid back>
        <v-row align="center"
        justify="center">
            <v-col>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="10" md="6" max-width="640px">
        
                        <v-card flat id="login-card" justify-center >

                            <v-row align="center" justify="center">
                                <v-img
                                    src="../assets/MejoraCareLogotype.svg"
                                    max-height="200px"
                                    max-width="200px"
                                    aspect-ratio="1"
                                    object-fit="contain"
                                    id="saludable-logo"
                                ></v-img>
                            </v-row>

                            <v-card-text>

                                <form>
                                <p class="form-label">
                                    EMAIL
                                </p>
                                <v-text-field
                                    name="login"
                                    type="email"
                                    v-model="email"
                                    outlined
                                    v-on:keyup.enter="onSignIn"
                                    v-on:keyup="onDismissedAlert"
                                />
                                <p class="form-label">
                                    CONTRASEÑA
                                </p>
                                <v-text-field
                                    id="password"
                                    name="password"
                                    type="password"
                                    v-model="password"
                                    required
                                    outlined
                                    v-on:keyup.enter="onSignIn"
                                    v-on:keyup="onDismissedAlert"
                                />
                                <v-layout
                                    align-center justify-center
                                    class="mb-5"
                                    v-if="loginAttempts > 2"
                                >
                                    <vue-recaptcha 
                                        :sitekey="recaptcha_key" 
                                        ref="recaptcha"
                                        @verify="onVerifyRecaptcha"
                                        @expired="onExpiredRecaptcha"
                                    />
                                </v-layout> 

                                <v-layout row v-if="error">
                                    <app-alert @dismissed="onDismissedAlert" text="Email o contraseña no son correctas."></app-alert>
                                </v-layout>
                                <v-spacer />
                                <v-btn 
                                    @click="onSignIn" 
                                    class="form-button" 
                                    color="primary"
                                    :disabled="loginAttempts > 2 && !verifyRecaptcha"
                                >
                                    Entrar
                                </v-btn>
                                </form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: "SignIn",

        components: { VueRecaptcha },

        data () {
            return {
                email: '',
                password:'',
                recaptcha_key: process.env.VUE_APP_RECAPTCHA_KEY,
                verifyRecaptcha: null
            }
        },
        methods: {
            onSignIn() {
                if (this.loginAttempts > 2 && !this.verifyRecaptcha) {
                    return;
                }

                this.$store.dispatch('admins/signUserIn', {email: this.email, password: this.password});
            },
            onDismissedAlert() {
                this.$store.dispatch('admins/clearError');
            },

            onVerifyRecaptcha: function (response) {
              this.verifyRecaptcha = response;
            },
            onExpiredRecaptcha: function () {
              this.verifyRecaptcha = null;
            },
            resetRecaptcha () {
              if (this.$refs.recaptcha) {
                this.$refs.recaptcha.reset()
                this.verifyRecaptcha = null;
              }
            },
            loadRecaptcha () {
              const url = `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=es`
              const $el = document.createElement('script')
              $el.src = url
              $el.async = true
              document.head.appendChild($el)
            }
        },
        watch: {
            user(value) {
                if (value!==null && value!=undefined) {
                    this.$router.push('/all-users');
                }
            },
            error(newVal, prevVal) {
                if (newVal !== prevVal && newVal !== null) {
                    this.resetRecaptcha()
                }
            }
        },
        computed: {
            user() {
                return this.$store.getters['admins/user'];
            },
            error() {
                return this.$store.getters['admins/error'];
            },
            loginAttempts() {
                return this.$store.getters['admins/loginAttempts'];
            }
        },
        beforeMount() {
            this.loadRecaptcha()
        }
    }
</script>

<style scoped lang="scss">
    #login-card {
      border-radius: 16px;
      box-shadow: 0 0 11px 4px rgba(181, 206, 233, 0.17);
      padding: 60px;
    }

    #cura-covid-logo {
        margin-bottom: 70px;
    }


</style>